export function escapeHTML(str: string): string {
  const span = document.createElement("span");
  span.appendChild(document.createTextNode(str));
  return span.innerHTML;
}
